module.exports = __webpack_public_path__ + "static/media/achievement.42d3ee82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/achievement.svg
// module id = 428
// module chunks = 0